import stateClass, {CHANGE_EVENT} from '../baseState';

const GROUP_CHANGE_EVENT = 'activeGroupsChange';
const ENABLE_EVENT = 'enable';
const DISABLE_EVENT = 'disable';
const RAW_DATA_UPDATE_EVENT = 'rawUpdate';

class schoolTypesStateClass extends stateClass{

    constructor(props) {
        super(props);

        this.activeGroups = [];

        this.groupKeys = [1, 2, 3, 4, 5, 6, 'all'];

        this.typeNameMap = {
            1: "valsts ģimnāzija",
            2: "vidusskola",
            3: "vakara (maiņu)/neklātienes vidusskola",
            4: "pamatskola",
            5: "sākumskola",
            6: "profesionālās izglītības iestāde",
            "all": "visas skolas"
        }

        this.filterField = 'Tips';

        this.colors = ["#fb4","#79c","#f66","#7d7","#acc","#fdd","#b9b"];

        this.colorsActive = true;

        this.colorKey = 'Tips';

        this.sizeField = 'kopa';

        this.rawdata = [];
    }

    setRawData(data) {

        this.rawdata = Object.assign({}, data);
        this.emit(RAW_DATA_UPDATE_EVENT);
    }
    getRawData() {

        return this.rawdata;
    }
    getColorKey() {

        return this.colorKey;
    }

    enable(active){

        this.colorsActive = true;
        this.emit(ENABLE_EVENT);
    }
    disable(inactive){

        this.colorsActive = false;
        this.emit(DISABLE_EVENT);
    }

    getColors() {
        
        return this.colors.slice();
    }
    
    /**
     * update school types
     * @param  {array} data [{id, count}]
     * @return {[type]}      [description]
     */
    
    getTypeNameMap() {

        return this.typeNameMap;
    }

    update(data){

        for (var i= data.length - 1; i >= 0; i--) {
            data[i].name = this.typeNameMap[data[i].id];
        }

        this.data = data;

        this.emit(CHANGE_EVENT);
    }

    toggleFilterGroup(groupID) {

        var index = this.activeGroups.indexOf(groupID);

        if(index > -1) { //turn off
            if(groupID === 'all'){
                this.activeGroups = [];
            } else {
                this.activeGroups.splice(index, 1);
            }
            
        } else { //turn on
            if(groupID === 'all'){

                var allgroups = this.groupKeys.slice();
                allgroups.push('all');

                this.activeGroups = allgroups;
            } else {
                this.activeGroups.push(groupID);
            }
        }

        this.emit(GROUP_CHANGE_EVENT);
    }

    setActiveGroups(groups) {

        if(typeof groups[0] !== 'undefined' && groups[0] === 'all') {

            this.activeGroups = this.groupKeys.slice();
        } else {
            this.activeGroups = groups;
        }

        this.emit(GROUP_CHANGE_EVENT);
    }
}

var SchoolTypesState = new schoolTypesStateClass();

export {SchoolTypesState, GROUP_CHANGE_EVENT, CHANGE_EVENT, ENABLE_EVENT, DISABLE_EVENT, RAW_DATA_UPDATE_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/schoolTypes/state.js